import PlayerInfoComponent from "../PlayerInfoComponent";

function PlayerHeaderComponent(props: {
  playerName: string;
  globalRank: number;
  totalPoints: number;
  freeTrades: number;
}) {
  const { playerName, globalRank, totalPoints, freeTrades } = props;
  return (
    <PlayerInfoComponent
      playerName={playerName}
      totalPoints={totalPoints}
      globalRank={globalRank}
      freeTrades={freeTrades}
    />
  );
}

export default PlayerHeaderComponent;
